export default __webpack_public_path__ + "static/media/cr_dbms.fcc553d5.jpg";